import Service from '@/utils/request';

/**
 *城管一张图首页相关接口
 */
const IndexApi = {
    /**
     * 获取河湖岛列表
     * @param {startTime:开始时间,endTime：结束时间} params
     * @returns
     */
    riverLakeIslandList: (params) => Service.get('/biz/hz/waterArea/allList', { params: { ...params } }),

    /**
     * 获取工程列表
     * @param {startTime:开始时间,endTime：结束时间} params
     * @returns
     */
    projectList: (params) => Service.get('/biz/hz/project/allList', { params: { ...params } }),

    /**
     * 获取日常巡查任务列表
     * @param {startTime:开始时间,endTime：结束时间} params
     * @returns
     */
    fetchDailyTaskList: (params) =>
        Service.get('/data/gridGroup/dailyTaskList', { params: { ...params, appCode: 'HZ' } }),

    /**
     * 获取正射地图列表
     *  @param {startTime:开始时间,endTime：结束时间} params
     * */
    fetchOrthoList: (params) => Service.get('/fcs/taskDataMap/listZs', { params: { ...params } }),

    /*
     * 查询事件类型树结构
     *  @param {} params
     * */
    fetchEventTypeTree: (params) => Service.get('/data/eventType/tree', params),

    /**
     * 获取事件列表
     *  @param {startTime:开始时间,endTime：结束时间} params
     * */
    fetchEventList: (params) =>
        Service.get('/data/eventInfo/list', {
            params: { ...params, appCode: 'HZ' },
        }),

    /**
     * 查询河湖岛工程统计
     *  @param {beginTime:开始时间,endTime：结束时间} params
     * */
    waterAreaStatistics: (params) =>
        Service.get('/biz/hz/waterArea/count', {
            params: {
                ...params,
            },
        }),

    /**
     * 服务数据统计
     *  @param {beginTime:开始时间,endTime：结束时间} params
     * */
    fetchServiceStatistics: (params) =>
        Service.get('/fcs/statistics/countServiceData', {
            params: {
                ...params,
                appCode: 'HZ',
            },
        }),
    /**
     * 服务项统计
     *  @param {beginTime:开始时间,endTime：结束时间} params
     * */
    fetchSubjectStatistics: (params) =>
        Service.get('/fcs/statistics/countSubjectData', {
            params: {
                ...params,
                appCode: 'HZ',
            },
        }),
    /**
     * 事件状态统计
     *  @param {startTime:开始时间,endTime：结束时间} params
     * */
    fetchEventStatusStatistics: (params) =>
        Service.get('/workbench/suspectedEventStatusStatistics', {
            params: {
                ...params,
                appCode: 'HZ',
            },
        }),
    /**
     * 事件类型统计
     *  @param {startTime:开始时间,endTime：结束时间} params
     * */
    fetchEventTypeStatistics: (params) =>
        Service.get('/workbench/suspectedEventTypeStatistics', {
            params: {
                ...params,
                appCode: 'HZ',
            },
        }),
    /**
     * 查询服务工单任务图片列表
     *  @param {startTime:开始时间,endTime：结束时间} params
     * */
    hzDataPicture: (params) =>
        Service.get('/biz/hz/data/picture', {
            params: {
                ...params,
                appCode: 'HZ',
            },
        }),
    /**
     * 查询事件列表
     *  @param {startTime:开始时间,endTime：结束时间} params
     * */
    hzDataEvent: (params) =>
        Service.get('/biz/hz/data/event', {
            params: {
                ...params,
                appCode: 'HZ',
            },
        }),

    /**
     * 查询关联对象的任务列表
     *  @param {startTime:开始时间,endTime：结束时间} params
     * */
    hzDataTask: (params) =>
        Service.get('/biz/hz/data/task', {
            params: {
                ...params,
                appCode: 'HZ',
            },
        }),

    /**
     * 查询关联对象的统计
     *  @param {startTime:开始时间,endTime：结束时间} params
     * */
    hzStatistics: (params) =>
        Service.get('/biz/hz/data/statisticsById', {
            params: {
                ...params,
            },
        }),

    /**
     * 获取工程详情
     * @param {id:工程id} id
     * @returns
     */
    projectInfo: (id) => Service.get(`/biz/hz/project/${id}`),

    /**
     * 河湖岛详情
     * @param {id:河湖岛id} id
     * @returns
     */
    waterAreaInfo: (id) => Service.get(`/biz/hz/waterArea/${id}`),

    /**
     * 查询河湖岛+工程列表
     *  @param {startTime:开始时间,endTime：结束时间} params
     * */
    waterAreahzList: (params) =>
        Service.get('/biz/hz/waterArea/hzList', {
            params: { ...params },
        }),

};
export default {
    ...IndexApi,
};
